import useSessionStorage from './useSessionStorage';

export const MODE = Object.freeze({
  deposit: 'deposit',
  withdraw: 'withdraw'
});

/**
 * Parses 'mode' query string parameter and caches for the session.
 * @returns {string} current mode
 */
function useMode() {
  const [mode, setMode] = useSessionStorage('vip-mode');
  const params = new URLSearchParams(window.location.search);
  const newMode = params.get('mode');
  if (newMode && newMode !== mode) {
    setMode(newMode);
    return newMode;
  }
  return mode;
};

export default useMode;
